import { getBODLEvents } from '../helpers';

export default class {
    constructor() {
        this.bodlEvents = getBODLEvents();
    }
}
